import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable } from 'rxjs';
import { ApiHelper } from 'src/app/shared/common/ApiHelper';
import { SwalHelper } from 'src/app/shared/common/SwalHelper';
import { ApiResponse } from '../../shared/models/ApiResponse';
import { Bonus } from './bonus.model';

@Injectable({
    providedIn: 'root'
})
export class BonusService {
    constructor(
        private _http: HttpClient,
        private _apiHelper: ApiHelper,
        private _swalHelper: SwalHelper,
        private _loaderService: NgxUiLoaderService,
    ) { }

    public get(employeeID: number): Observable<Bonus[]> {
        return this._http.get<Bonus[]>(`/api/employees/${employeeID}/bonuses?widget=EMPLOYEE_BONUS`);
    }

    public saveBonus(form: Bonus, employeeID: number, bonusID?: number | string): Promise<string> {
        this._loaderService.start();
        const apiUrl = bonusID ? `/api/employees/${employeeID}/bonuses/${bonusID}` : `/api/employees/${employeeID}/bonuses`;
        return new Promise(resolve => {
            this._http.post(apiUrl, form).subscribe((response: any) => {
                this._apiHelper.handleSuccessResponse(response);
                resolve('done');
                this._loaderService.stop();
            }, error => {
                this._apiHelper.handleErrorResponse(error);
                this._loaderService.stop();
            });
        });
    }

    public deleteBonus(employeeID: number, bonusID: number | string): Promise<string> {
        return new Promise(async (resolve, reject) => {
            const deleteConfirmed = await this._swalHelper.showConfirmDeleteDialog();
            if (deleteConfirmed) {
                this._loaderService.start();
                this._http.delete(`/api/employees/${employeeID}/bonuses/${bonusID}`, {}).subscribe((response: ApiResponse) => {
                    this._loaderService.stop();
                    this._apiHelper.handleSuccessResponse(response);
                    resolve('done');
                }, error => {
                    this._loaderService.stop();
                    this._apiHelper.handleErrorResponse(error);
                });
            } else {
                reject('error');
            }
        });
    }
}
